module.exports = __webpack_public_path__ + "images/emoji/flashlight.412f5ede34653134f0f0.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/flashlight.png
// module id = /UcX
// module chunks = 14